<template>
    <div class="lesson_main" :style="{backgroundColor:getCourseSubColor(courseId)}">
        <HeaderNav v-if="!isWeixinBrowser()" :navtitle="lessonTitle" :beforecolor="'#fff'" :backcolor="getCourseSubColor(courseId)" @returnBack="goToBack"></HeaderNav>
        <div class="lesson_audio">
            <div class="info">
                <div class="title">学前听一听</div>
                <div class="mp3_progress">
                    <div class="now_progress" v-bind:style="{width: progress+ '%'}"></div>
                </div>
                <div class="time">
                    <div class="time_start">{{realFormatSecond(currentTime)}}</div>
                    <div class="time_end">{{objPartInfo.explainAudioDurationDisplayString}}</div>
                    <div class="clear"></div>
                </div>
            </div>
            <div class="play" @click="changeStart">
                <audio v-bind:src="$qiNiuDomainBase + objPartInfo.explainAudio"  id="musicMp3" controls=""></audio>
                <img v-if="!isPlay" src="@/assets/player_play.png" height="40" width="40"/>
                <img v-else src="@/assets/player_pause.png" height="40" width="40"/>
            </div>
            <div class="clear"></div>
        </div>
        <div class="words_list" v-if="objPartInfo.wordArray != null && objPartInfo.wordArray.length > 0">
            <div class="title">词汇清单</div>
            <div class="list">
                <div class="word_card_item" v-for="(wordCard,index) in objPartInfo.wordArray" :key="index" @click="wordClick(wordCard.youdaoUrl, wordCard.pk, wordCard.word)">
                    <div class="word" v-bind:style="{color:isEmpty(wordCard.youdaoUrl) ? '#ff5050' : '#333333'}">{{wordCard.word}}</div>
                    <div class="example">{{wordCard.translation}}</div>
                    <div class="card_in">{{!isEmpty(wordCard.youdaoUrl) ? "详细释义 >" : "词卡 >"}}</div>
                </div>
                <div class="clear"></div>
            </div>
            <div class="bottom"></div>
        </div>
        <div class="start_learn" @click="startLearnClick">
            <div class="btn" v-bind:style="{backgroundColor:getCourseMainColor(courseId)}">开始学习</div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                courseId:0,
                lessonId:0,
                partNo: "",
                lessonTitle:"",
                group:"",
                groupName:"",
                objPartInfo:{},
                progress: 0,
                isPlay: false,
                currentTime:0,
                mTimer:null
            }
        },
        methods: {
            goToBack() {
                this.goBack(this.$router);
            },
            wordClick:function(youdaoUrl, pk, word) {
                if(!this.isEmpty(youdaoUrl)) {
                    this.$router.push({name: 'pageView', query: {url: "https://m.youdao.com/dict?le=eng&q=" + word}});
                } else {
                    this.$router.push({
                        name: 'wordCard', query: {courseId: this.courseId, wordId: pk, word: word}
                    });
                }
            },
            startLearnClick:function() {
                this.$router.push({
                    name: "Sentence",
                    query: {
                        courseId: this.courseId,
                        lessonId: this.lessonId,
                        partNo: this.partNo,
                        sentenceIndex: 0,
                        lessonTitle: this.lessonTitle,
                        group: this.group,
                        groupName: this.groupName
                    }
                });
            },
            changeStart: function () {
                let that = this;
                that.isPlay = !that.isPlay
                const musicMp3 = document.getElementById('musicMp3')
                if (that.isPlay) {
                    if (that.mTimer == null) {
                        that.changeProgress();
                    }
                    musicMp3.play()
                } else {
                    musicMp3.pause()
                }
            },
            changeProgress: function () {
                let that = this;
                const musicMp3 = document.getElementById('musicMp3')

                that.mTimer = setInterval(() => {
                    const numbers = musicMp3.currentTime / musicMp3.duration
                    let perNumber = (numbers * 100).toFixed(2)
                    if (perNumber >= 100) {
                        that.isPlay = false
                        that.progress = 0
                        that.currentTime = 0
                        clearInterval(that.mTimer)
                        that.mTimer = null;
                    } else {
                        that.progress = perNumber
                        that.currentTime = musicMp3.currentTime;
                    }
                }, 50)
            },
            callChangeProgress:function () {
                let that = this;
                document.getElementById('musicMp3').pause()
                that.changeProgress()
            }
        },
        mounted: function () {
            this.callChangeProgress();
            window.LessonPartScrollTop = 0;
        },
        beforeRouteLeave(to, from, next) {
            window.LessonPartScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            next()
        },
        activated() {
            window.scrollTo(0, window.LessonPartScrollTop);
        },
        beforeCreate () {
            let vCourseId = parseInt(this.$route.query.courseId);
            let vlessonId = parseInt(this.$route.query.lessonId);
            let vPartNo = this.$route.query.partNo;
            let vLessonTitle = this.$route.query.lessonTitle;
            let vGroup = this.$route.query.group;
            let vGroupName = this.$route.query.groupName;
            let url = "240words/getPartExplainAudioAndWords/" + vlessonId + "/" + vPartNo;
            let that = this;

            this.$axios.get(url).then((response) => {
                that.objPartInfo = response.data;
                that.courseId = vCourseId;
                that.lessonId = vlessonId;
                that.partNo = vPartNo;
                that.lessonTitle = vLessonTitle;
                that.group = vGroup;
                that.groupName = vGroupName;
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        destoryed() {
            let that = this;

            if (that.mTimer != null) {
                clearInterval(that.mTimer)
                that.mTimer = null
            }
        }
    }
</script>

<style scoped>
.lesson_main {
    position:absolute;
    width:100%;
    height:auto;
    min-height: 100%;
}
.lesson_audio {
    position: relative;
    background-color: white;
    margin: 20px 20px 0px 20px;
    padding: 15px;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
}
.lesson_audio .info {
    margin-right: 50px;
}
.lesson_audio .play {
    position: absolute;
    top: 50%;
    right: 15px;
    -webkit-transform:translateY(-50%);
}
.lesson_audio .info .title {
    font-size: 15px;
    font-weight: bold;
    color: #333333;
}
.lesson_audio .info .mp3_progress {
    width: 100%;
    height: 4px;
    background-color: #f4f4f4;
    margin-top: 10px;
    margin-bottom: 10px;
}
.lesson_audio .info .now_progress {
    position: relative;
    @extend %transition;
    height: 4px;
    background-color: #64c846;
}
.lesson_audio .time {
    font-size: 12px;
    color: #999999;
}
.lesson_audio .time .time_start {
     float: left;
}
.lesson_audio .time .time_end {
    float: right;
}
audio{
    display: none;
}
.words_list .title {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-top: 30px;
}
.words_list .bottom {
    height: 80px;
}
.words_list .list {
    margin-top: 20px;
    margin-left: 7px;
    margin-right: 8px;
}
.words_list .list .word_card_item {
    background-color: white;
    width: calc((100% - 30px)/2);
    margin-left: 8px;
    margin-right: 7px;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    margin-bottom: 15px;
    float: left;
}
.words_list .list .word_card_item .word {
    margin-top: 15px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
}
.words_list .list .word_card_item .example {
    text-align: center;
    font-size: 17px;
    color: #333333;
    margin-top: 15px;
}
.words_list .list .word_card_item .card_in {
    text-align: center;
    font-size: 15px;
    color: #999999;
    margin-top: 5px;
    margin-bottom: 15px;
}
.start_learn {
    position:fixed;
    bottom: 0px;
    height: 70px;
    background-color: white;
    width: 100%;
}
.start_learn .btn {
    height: 50px;
    margin-top: 10px;
    text-align: center;
    color: white;
    font-size: 20px;
    line-height: 50px;
    margin-left: 30px;
    margin-right: 30px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    margin-bottom: 25px;
}
</style>
